module.exports = __webpack_public_path__ + "img/ic_pumper.e3826578.png";